export const TypeNameBlockFocus = 'ParagraphBlockFocus';
